import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'main-tai-chi-walking': {
			landing: {
				experiment: () => import('@/modules/Landing/instances/experiments/web_tai_chi_main_v2_social_proof'),
			},
		},
		'activity-female-tai-chi-walking-v2': {
			landing: {
				experiment: () => import('@/modules/Landing/instances/experiments/web_tai_chi_fem_v2_social_proof'),
			},
			// ?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_tai_chi_fem_v2_social_proof~1
			funnel: {
				id: 'ob-female-tai-chi-walking-social-proof',
				locale: ['en'],
			},
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_tai_chi_fem_v2_social_proof~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_tai_chi_fem_v2_social_proof'
					),
			},
		},
	},
]

export default config
